import React from "react";
import Navbar from "../assets/navbar";

import { Center, Image, Heading, Box, Text,Flex ,Link} from "@chakra-ui/react";

export default function HomePage() {
  return (
    <>
      <Navbar />
    
      <Center>
        <Box>
        <Image src="logo.svg" h="600px"/>
        </Box>
      </Center>
      <Center>
        <Box maxW="xxl" mx={6}>
          <Heading >A platform made for learning about malware behaviour on windows machines</Heading>
        </Box>
      </Center>
      <Center>
      <Box maxW="xxl" mx={6}>
        <Heading >In fun, safe and highly accessible environment</Heading>
      </Box>
      </Center>

      <Center>
        <Box>
        <Image src="it_vest_logo.jpg" h="200px"/>
        </Box>
      </Center>

      
     
      <Center>
        <Box  mt={12} mx={6} maxW="xl">
          <Heading size="xl" color='blue.900'>Developed by:</Heading>
        </Box>
      </Center>
      
      <Center>
        <Flex gap={5} >
        <Box mx={6} maxW="xl">
          <Text fontSize='30px'color='blue.800'>
            Markus Heinrich Toribio
          </Text>
          <Text fontSize='20px'>
            Student Developer, Department of Electronic Systems, Aalborg University
          </Text>
        </Box>
        <Box mx={6} maxW="xl">
          <Text fontSize='30px'color='blue.800'>
            Kim Christensen
          </Text>
          <Text fontSize='20px'>
            Reasearch Assistant, Department of Electronic Systems, Aalborg University
          </Text>
        </Box>
        <Box maxW="xl">
          <Text fontSize='30px' color='blue.800'>
           Kristian Helmer Kjær Larsen
          </Text>
          <Text fontSize='20px'>
            Reasearch Assistant, Department of Electronic Systems, Aalborg University
          </Text>
        </Box>
        </Flex>
        
      </Center>
      <Center>
      <Box maxW="xl">
          <Text fontSize='30px' color='blue.800'> Github: </Text>
          <Link href="https://github.com/aau-network-security/malware-in-a-box" >
          <Text fontSize='16px'>https://github.com/aau-network-security/malware-in-a-box </Text>
          </Link>
        </Box>
      </Center>
    </>
  );
}
